module.exports = __webpack_public_path__ + "img/016-project.5e56cad2.svg";